import { render, staticRenderFns } from "./project-issues.vue?vue&type=template&id=079d772a"
import script from "./project-issues.vue?vue&type=script&lang=js"
export * from "./project-issues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports